import store from "@/store";
import { error, success } from "@/plugins/snack/snack";
import { eventBus } from "@/utils";
import ReviewDocument from "@/modules/model/reviewDocument";
import Profile from "@/modules/application/models/profile";

class Upgrade extends ReviewDocument {
  profile = new Profile();
  loading = false;
  approveCaption =
    process.env.VUE_APP_ORG_NAME === "EBK" ? "Approve" : "Forward";

  constructor(line) {
    delete line.comments;
    super(line);
  }

  // get name() {
  //   return this.name;
  // }

  get reviewerName() {
    let reviewer = store.getters["Setup/reviewers"]
      .filter((r) => r.code === this.assignedReviewUser)
      .shift();
    return reviewer ? reviewer.names : "";
  }

  get comments() {
    return this.membershipComments || [];
  }

  get logs() {
    return this.reviewLogs
      ? this.reviewLogs.map((l) => {
          l["reviewer"] = store.getters["Setup/reviewers"]
            .filter((r) => r.code === l.reviewedBy)
            .shift();

          return l;
        })
      : [];
  }

  loadProfile() {
    this.loading = true;
    store
      .dispatch("Application/getMemberProfile", {
        ProfileID: this.profileID,
      })
      .then((res) => {
        let profile = res.data.data;
        this.profile = new Profile(profile);
        console.log("current upgrade ", this);
        this.loading = false;
      });
  }

  loadDocuments() {
    this.loading = true;
    this.profile.loadApplicationDetails(this.code);
    this.profile.loadCertifications();
    this.profile.loadMembershipInstitutions();
    this.profile.loadAttachments();
    console.log(this.profile.documents);

    eventBus.$emit("open-viewer", this.profile.documents);
    this.loading = false;
  }

  forward(refresh = true) {
    this.loading = true;

    store
      .dispatch("Upgrade/forward", { ...this })
      .then(() => {
        if (refresh) {
          store.dispatch("Upgrade/getUpgrades");
          success(`Successfully Approved`);
        }
        this.loading = false;
      })
      .catch((err) => {
        error(err.response.data.message);
        this.loading = false;
      });
  }

  rewind(refresh = true) {
    this.loading = true;

    store
      .dispatch("Upgrade/rewind", { ...this })
      .then(() => {
        if (refresh) {
          store.dispatch("Upgrade/getUpgrades");
          success("Successfully Approved");
        }
        this.loading = false;
      })
      .catch((err) => {
        error(err.response.data.message);
        this.loading = false;
      });
  }

  hold(refresh = true) {
    this.loading = true;

    store
      .dispatch("Upgrade/hold", { ...this })
      .then(() => {
        if (refresh) {
          store.dispatch("Upgrade/getUpgrades");
          success("Successfully put on hold");
        }

        this.loading = false;
      })
      .catch((err) => {
        error(err.response.data.message);
        this.loading = false;
      });
  }

  decline(refresh = true) {
    this.loading = true;

    store
      .dispatch("Upgrade/decline", { ...this })
      .then(() => {
        if (refresh) {
          store.dispatch("Upgrade/getUpgrades");
          success("Successfully declined");
        }
        this.loading = false;
      })
      .catch((err) => {
        error(err.response.data.message);
        this.loading = false;
      });
  }

  forwardPRB(refresh = true) {
    this.loading = true;

    store
      .dispatch("Upgrade/forwardPRB", { ...this })
      .then(() => {
        if (refresh) {
          store.dispatch("Upgrade/getUpgrades");
          success("Successfully forwarded to PRB");
        }
        this.loading = false;
      })
      .catch((err) => {
        error(err.response.data.message);
        this.loading = false;
      });
  }
}

export default Upgrade;
